import React, { useMemo } from 'react';
import { useLoggedInUser, useFeatureFlags } from '@tcc/shared-data-lib';
import { importFromS3 } from '../../utils/importFromS3';
import { useUserLoggedInConfigs, useFeatureFlagsConfigs } from '../../utils/sharedData';

const S3Plugin = React.lazy(() => importFromS3('tcc-operation-hub'));

export const OperationHubPluginContainer: React.FC = () => {
  const { user } = useLoggedInUser(useUserLoggedInConfigs);
  const { featureFlags } = useFeatureFlags(useFeatureFlagsConfigs(user));
  const useModuleFederation = featureFlags?.['web.operationHub.module-federation'];

  const OperationHubPlugin = useMemo(() => {
    if (useModuleFederation) {
      return React.lazy(() => import('operationHub/OperationHub'));
    }
    return S3Plugin;
  }, [useModuleFederation]);

  return <OperationHubPlugin />;
};
